import axiosFiles from '../../axiosFiles.js'

export default axiosFiles
